module.exports = __webpack_public_path__ + "assets/img/PJ-Signup.fe29457a.png";